export const LOCALES = {
    ENGLISH: "en-GB",
    SPANISH: "es",
    FRENCH: "fr",
    POLISH: "pl",
    ITALIAN: "it",
    GERMAN: "de",
  };